import type { DailyGameState } from '@/types'
import type { RouteRecordProps } from 'env'
import type { RouteRecordRaw } from 'vue-router'

import fetchDailyGameState from './guards/fetch-daily-game-state'

export default [
  {
    path: '/daily-spins',
    name: 'daily-spins',
    component: () => import('../views/DailySpins.vue'),
    meta: {
      title: 'Daily Spin & Win',
    },
    props: (route: RouteRecordProps<{ gameState: DailyGameState }>) => {
      return {
        gameState: route.meta.props?.gameState,
      }
    },
    beforeEnter: fetchDailyGameState,
  },
] as Readonly<RouteRecordRaw[]>
